import baseUrl from './baseUrl';

let reportUrl = 'https://demoapi.giztix.com';
if (baseUrl === 'https://api.giztix.com') {
    reportUrl = 'https://giztixgps.giztix.com';
}
export default reportUrl;
